module.exports = "<div class=\"{{class}}\" [style.min-height]=\"isHidden()\">\n\t<input\n\t\tclass=\"form-control input-sm\"\n\t\t[type]=\"type\"\n\t\t[placeholder]=\"placeholder\"\n\t\t[(ngModel)]=\"_value\"\n\t\t[readonly]=\"readonly\"\n\t\t(change)=\"onInputChange()\"\n\t\t(blur)=\"onInputTouched()\"\n\t/>\n\t<div *ngIf=\"errorMessage\" class=\"help-block\">{{errorMessage}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/input/input.html
// module id = 534
// module chunks = 0